import { CrFilter, isCrFilter } from '../../../customer-review-star-filter/types';
import { isSortParameter } from '../../types';
import { reloadReviewList } from './reload-review-list';
import { setUrlSearchParam } from '../../../_common/client/set-url-search-param';
import { removeUrlSearchParam } from '../../../_common/client/remove-url-search-param';
import { updateCurrentPageInHtml } from './pagination/update-current-page-in-html';
import { enableOrDisablePaginationButtons } from './pagination/enable-or-disable-pagination-buttons';
import { trackSortingEvent } from './track-sorting-event';
import { WindowLocation } from '../../../_common/client/window-location';
import { OcDropdownV1Events } from '@otto-ec/otto-components/dropdown';

export const registerOnSortSelectionChange = (rootElement: HTMLElement) => {
    const sortSelection = rootElement.querySelector<HTMLSelectElement>('oc-dropdown-v1.cr_list-wrapper__sort-selection-dropdown');
    if (!sortSelection) return;

    sortSelection.addEventListener('oc-property-change', async (event: OcDropdownV1Events['oc-property-change']) =>
        handleSortSelectionChange(event, rootElement)
    );
};

const handleSortSelectionChange = async (event: OcDropdownV1Events['oc-property-change'], rootElement: HTMLElement) => {
    const value = event.detail.value?.current;
    if (!value || !isSortParameter(value)) return;
    await reloadReviewList(rootElement, getFilterFromUrlParam(), value);
    setUrlSearchParam('sort', value);
    const previousPage = getPageFromUrlParam();
    removeUrlSearchParam('page');
    updateCurrentPageInHtml(1, rootElement);
    enableOrDisablePaginationButtons(1, rootElement);
    trackSortingEvent(value, previousPage || 1);
};

const getFilterFromUrlParam = (): CrFilter | undefined => {
    const reviewFilterSearchParam = new URLSearchParams(WindowLocation.getSearch()).get('filter');
    return reviewFilterSearchParam && isCrFilter(reviewFilterSearchParam) ? reviewFilterSearchParam : undefined;
};

const getPageFromUrlParam = (): number | undefined => {
    const pageSearchParam = new URLSearchParams(WindowLocation.getSearch()).get('page');
    return pageSearchParam && !isNaN(parseInt(pageSearchParam)) ? parseInt(pageSearchParam) : undefined;
};
